import PropTypes from 'prop-types';

import { Box, Button, Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import CommunitySvg from '../../../res/svg/community.svg';

const JoinCommunityComponent = (props) => {
  const { t } = useTransl();
  const { onJoinCommunity, onCancel } = props;
  return (
    <>
      <Box display="flex" justifyContent="center" my="3rem">
        <img src={CommunitySvg} alt="Community Img" />
      </Box>
      <Typography variant="h5" fontWeight="bold" textAlign="center">
        {t('title.community')}
      </Typography>
      <Box display="flex" flexDirection="column" gap="1rem" p="1rem">
        <Typography textAlign="justify">{t('community.joinNote')}</Typography>
        <Box mt="1rem" />
        <Button
          variant="contained"
          onClick={onJoinCommunity}
          disableElevation
          fullWidth
        >
          {t('community.joinCommunity')}
        </Button>
        <Button color="inherit" onClick={onCancel} fullWidth>
          {t('community.noThanks')}
        </Button>
      </Box>
    </>
  );
};

JoinCommunityComponent.propTypes = {
  onJoinCommunity: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default JoinCommunityComponent;
